
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import BuildingOwnersContainer from './building-owner/container/BuildingOwnersContainer';
import BuildingApplicationContainer from './application/container/BuildingApplicationContainer';
import BuildingSettingsContainer from './settings/BuildingSettingsContainer';
import AdditionalItemsContainer from './application/components/additional-costs/container/AdditionalCostsContainer';
import { GET_FORMDATA_ORDINANCE_REVISION_RPT } from '../components/constant';
import OrdinanceRevisionDropdown from '../components/OrdinanceRevisionDropdown';

function BuildingContainer({ match, pathName }) {
  const permissions = getJson('permissions');

  const dropDownFormData = useSelector(
    ({ api }) => _.get(api, `${GET_FORMDATA_ORDINANCE_REVISION_RPT}.item`) || {}
  );

  localStorage.getItem('defaultFormValue');

  const ordinanceRevisionId =
    parseInt(_.get(dropDownFormData, 'year.value'), 10) ||
    JSON.parse(localStorage.getItem('defaultFormValue'))?.year?.value;

  return (
    <React.Fragment>
      <div className="card-content-listing px-0">
        <div className="container-fluid">
          <div className="row custom-nav-links">
            <ul className="nav nav-tabs tab-container">
              {Acl(permissions, ['E2E RPT BUILDING APPLICATIONS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/building/applications"
                    className={`nav-link per-tab ${pathName.indexOf('rpt/building/applications') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Applications
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT BUILDING OWNERS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/building/building-owners"
                    className={`nav-link per-tab ${pathName.indexOf('rpt/building/building-owners') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Building Owners
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT BUILDING SETTINGS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/building/settings"
                    className={`nav-link per-tab ${pathName.indexOf('rpt/building/settings') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Settings
                  </Link>
                </li>
              )}
            </ul>
            {
              <div className="d-flex ml-auto">
                <div
                  className="d-flex justify-content-end align-items-center mr-5"
                  style={{ flexGrow: '2' }}
                >
                  <OrdinanceRevisionDropdown pathName={pathName} />
                </div>
              </div>
            }
          </div>
        </div>
        <Switch>
          {Acl(permissions, ['E2E RPT BUILDING APPLICATIONS']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/applications`} />}
            />
          )}
          {Acl(permissions, ['E2E RPT BUILDING APPLICATIONS']) && (
            <Route
              path={`${match.path}/applications`}
              render={() => (
                <BuildingApplicationContainer 
                  ordinanceRevisionId={+ordinanceRevisionId}
                />
              )}
            />
          )}
          {Acl(permissions, ['E2E RPT BUILDING OWNERS']) && (
            <Route
              path={`${match.path}/building-owners`}
              component={BuildingOwnersContainer}
            />
          )}
          {/* {Acl(permissions, ['E2E RPT BUILDING ADDITIONAL ITEMS']) && ( */}
          <Route
            path={`${match.path}/additional-items`}
            component={AdditionalItemsContainer}
          />
          {/* )} */}
          {Acl(permissions, ['E2E RPT BUILDING SETTINGS']) && (
            <Route
              path={`${match.path}/settings`}
              render={() => (
                <BuildingSettingsContainer
                  ordinanceRevisionId={+ordinanceRevisionId}
                />
              )}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

BuildingContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(BuildingContainer);
